import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { useUpdateUserJobParams } from './interfaces';
import { transformJobs } from './utils/transform-jobs';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import type { UserJob } from '@/models/taxonomy/job';

const baseUrl = '/api/account/user_jobs';

export const useUserJobsIndex = () => {
  const response = useQuery<UserJob[]>({
    queryKey: [clientKeys.useUserJobsIndex],
    queryFn: async () => await falconClient.get(baseUrl),
  });

  return {
    ...response,
    jobs: transformJobs(response?.data ?? []),
  };
};

export const useUpdateUserJobs = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ title_id, job_type }: useUpdateUserJobParams) => {
      return await falconClient.put(baseUrl, {
        title_id,
        job_type,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [clientKeys.useUserJobsIndex],
      });
      await queryClient.invalidateQueries({
        queryKey: [clientKeys.useUserPrioritySkillSetsIndex],
      });
    },
  });
};
